import { render, staticRenderFns } from "./title-editor.vue?vue&type=template&id=3f4738b7&scoped=true&"
import script from "./title-editor.vue?vue&type=script&lang=js&"
export * from "./title-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4738b7",
  null
  
)

export default component.exports